import { parse } from 'qs';
import React from 'react';
import { GravityForm } from '@teliaee/gravity-forms';
import { LanguageContext, EnvironmentContext } from '@telia-common-components/shared';
import { useInternetCalculator } from '../InternetCalculatorProvider';
const GravityFormWrapper = (props) => {
    const { cmsData, formsList, credentialsAllowed, navigate, clientAuth, ...rest } = props;
    const { lang } = React.useContext(LanguageContext);
    const { tier } = React.useContext(EnvironmentContext);
    const { setModalState } = useInternetCalculator();
    return (React.createElement(GravityForm, { ...rest, app: 'telia', language: lang, env: (tier || 'live'), decodedParams: parse(window.location.search, { ignoreQueryPrefix: true }), navigate: navigate || window.location.replace, clientAuth: clientAuth, pathname: window.location.pathname || '/', credentialsAllowed: credentialsAllowed || false, formsList: formsList, cmsData: cmsData, onClose: () => setModalState({ offer: null, showForm: false }) }));
};
export default GravityFormWrapper;
